import React from 'react'
import ClientNavbar1 from './ClientNavbar1';
import ClientNavbar from './ClientNavbar'
import ClientNavbar2 from './ClientNavbar2'
import { useAuth } from "../../Context/UserContext";
import './Page-css/ViewVulnerabilities.css'
import { Icon } from '@iconify/react'
import { useNavigate, useParams } from 'react-router-dom';
import { url } from '../../constants/url';
import { useEffect } from 'react';
import { useState } from 'react';
import Dropdown from '../Modal/DropDown';
import ViewVulnerabilitiesAttachment from '../Modal/ViewVulnerabilityAttachment';
import { toast } from 'react-toastify';
import { faCaretRight, faL, faPlus, faTrash, } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ViewVulnerabilities = () => {

    const [openAssignDropdown, setOpenAssignDropdown] = useState(false);
    const { isSidebarCollapsed, logout, userRole, emailVer, userPermission } = useAuth();
    const { id } = useParams()
    const [isMobileView, setIsMobileView] = useState(false)
    const [showVulDetails, setShowVulDetails] = useState(false);
    const [projectId, setProjectId] = useState('')
    const navigate = useNavigate();

    const [vulnerabilityData, setVulnerabilityData] = useState('')
    const [allVulnerabilityData, setAllVulnerabilityData] = useState([])
    const [selectedVulId, setSelectedVulId] = useState(null);
    const [pocImages, setPocImages] = useState([]);
    const [comments, setComments] = useState('')
    const [commentError, setCommentError] = useState('')
    const [saveVisible, setSaveVisible] = useState(false)
    const [applicationType, setApplicationType] = useState('')
    const [pocFiles, setPocFiles] = useState([]);
    const [remidiationPoc, setremidiationPoc] = useState([])
    const [loading, setLoading] = useState(false)
    const [updateLoading, setUpdateLoading] = useState(false)
    const [pocChanged, setPocChanged] = useState(false);
    const [viewPocIndex, setViewPocIndex] = useState(null);



    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 430);
        };
        handleResize(); // Set initial value
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const clientCommentError = () => {
        toast.error("Error while saving comment", {
            position: "top-right",
            autoClose: 2500,
            pauseOnHover: false,
        });
    };

    const clientCommentSuccess = () => {
        toast.success("Comment added successfully", {
            position: "top-right",
            autoClose: 2500,
            pauseOnHover: false,
        });
    };


    const handleVulClick = (vulId) => {
        navigate(`/viewvulnerabilities/${vulId}`);
        fetchVulnerabilityData(vulId)
        fetchPOCImages(vulId)
    };

    const getStatus = (status) => {
        if (status === 'Inprogress') {
            return 'status_inprogress';
        } else if (status === 'Closed') {
            return 'status_closed';
        } else if (status === 'Open') {
            return 'status_open';
        } else if (status === 'Reopen') {
            return 'status_reopen'
        }
        return '';
    };

    const options = ['Open', 'Closed', 'Reopen'];

    const formatDate = (dateString) => {
        const options = { day: "2-digit", month: "2-digit", year: "numeric" };
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", options);
    };

    const fetchVulnerabilityData = async (vulId = id) => {
        setSelectedVulId(vulId);
        try {
            const response = await fetch(`${url}/viewvulnerabilitydata?id=${vulId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            });

            const data = await response.json();
            setVulnerabilityData(data.vulnerabilityDetails);
            setApplicationType(data.projectData.applicationType)
            if (response.status === 403) {
                logout()
                return
            }

        } catch (error) {
            console.log('Error fetching vulnerability:', error);
        }
    };

    const fetchPOCImages = async (vulId = id) => {
        try {
            const response = await fetch(`${url}/fetchpoc?vulnerabilityId=${vulId}`, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include'
            });

            if (response.status === 440) {
                return navigate('/');
            }

            const fetchedFiles = await response.json();

            // Now fetch each file as a blob and convert to object URL
            const imageBlobs = await Promise.all(
                fetchedFiles.map(async file => {
                    try {
                        const imageResponse = await fetch(file.url, {
                            method: 'GET',
                            credentials: 'include'
                        });

                        const blob = await imageResponse.blob();
                        const objectUrl = URL.createObjectURL(blob);

                        return {
                            fileName: file.fileName,
                            objectUrl, // Use this in <img src={objectUrl} />
                            lastModified: file.lastModified,
                            size: file.size,
                            pocFolder: file.pocFolder,
                        };
                    } catch (err) {
                        console.error(`Failed to fetch image blob for ${file.fileName}`, err);
                        return null;
                    }
                })
            );

            // Filter out any failed blob fetches
            const validImages = imageBlobs.filter(img => img !== null);

            setPocImages(validImages);
            console.log(validImages);

        } catch (error) {
            console.error("Error fetching PoC images:", error);
        }
    };


    const fetchAllVulnerability = async () => {
        try {
            const response = await fetch(`${url}/allclientvulnerability?id=${id}`, {
                method: 'GET',
                headers: {
                    "Content-Type": 'application/json'
                },
                credentials: 'include'
            });

            const data = await response.json();
            setSaveVisible(false)
            setAllVulnerabilityData(data)

        } catch (error) {
            console.log('Error fetching vulnerability:', error);
        }
    };

    const handleSaveComment = async (id) => {
        if (comments === '') {
            return setCommentError('This field is required')
        }
        try {
            const response = await fetch(`${url}/updateclientcomment`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'include',
                body: JSON.stringify({
                    vulnerabilityId: id,
                    comment: comments
                })
            })

            if (response.ok) {
                setComments('')
                // setOpenComment(null);
                const result = await response.json();
                setVulnerabilityData(result.vulnerability)
                clientCommentSuccess();
                fetchVulnerabilityData()
            }
            if (response.status === 401) {
                toast.error("Only project owner can add comments", {
                    position: "top-right",
                    autoClose: 2500,
                    pauseOnHover: false,
                });

            }
            if (response.status === 440) {
                logout()
                toast.error("User logout due to inactivity", {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
                return
            }

        } catch (error) {
            console.log(error)
            clientCommentError();
        }
    }

    const handleAcceptVulnerability = async (id) => {
        try {

            const response = await fetch(`${url}/acceptvulnerability?vulnerabilityId=${id}`, {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: 'include'
            })

            if (response.status === 200) {
                fetchVulnerabilityData()
                toast.success('Vulnerability Accepted...', {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            }

            if (response.status === 404) {
                toast.error('Vulnerability not found...', {
                    position: 'top-right',
                    autoClose: 2500,
                    pauseOnHover: false,
                });
            }

        } catch (error) {
            console.log(error)
        }
    }

    const handleSubmitPoc = async () => {
        setLoading(true)
        try {
            const formData = new FormData();

            pocFiles.forEach((file) => {
                formData.append("poc", file);
            });

            const response = await fetch(
                `${url}/uploadpoc?vulnerabilityId=${id}`,
                {
                    method: "POST",
                    credentials: "include",
                    body: formData
                }
            );

            const data = await response.json();

            if (response.ok) {
                toast.success("POC files uploaded successfully");

                setPocFiles([]);
                await fetchPoc(id)

            } else {
                toast.error(data.message || "Failed to upload POC files");
            }

        } catch (error) {
            console.error(error);
            toast.error("Failed to upload POC files");
        }
        finally {
            setLoading(false)
        }
    };

    const fetchPoc = async (vulId) => {
        try {
            const response = await fetch(`${url}/fetch-remediation-poc?vulnerabilityId=${vulId}`,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: "include"
                }
            )

            if (response.status === 440) {
                return navigate('/');
            }

            const fetchedFiles = await response.json();


            // Now fetch each file as a blob and convert to object URL
            const imageBlobs = await Promise.all(
                fetchedFiles.map(async file => {
                    try {
                        const imageResponse = await fetch(file.url, {
                            method: 'GET',
                            credentials: 'include'
                        });

                        const blob = await imageResponse.blob();
                        const objectUrl = URL.createObjectURL(blob);

                        return {
                            fileName: file.fileName,
                            objectUrl,
                            lastModified: file.lastModified,
                            size: file.size,
                            pocFolder: file.pocFolder,
                            filePath: file.filePath,
                        };
                    } catch (err) {
                        console.error(`Failed to fetch image blob for ${file.fileName}`, err);
                        return null;
                    }
                })
            );


            const validImages = imageBlobs.filter(img => img !== null);

            setremidiationPoc(validImages);
        }
        catch (error) {
            console.error(error)
        }
    }

    const handleUpdatePoc = async () => {
        setUpdateLoading(true)
        try {
            const formData = new FormData();

            formData.append("vulnerabilityId", id);

            // Existing remediation POCs that the user kept
            remidiationPoc.forEach((poc) => {
                console.log(poc.filePath)
                if (poc.filePath) {
                    formData.append(
                        "existingPocs",
                        poc.filePath
                    );
                }
            });


            pocFiles.forEach((file) => {
                formData.append("poc", file);
            });

            const response = await fetch(
                `${url}/update-remediation-poc`,
                {
                    method: "PUT",
                    credentials: "include",
                    body: formData
                }
            );

            const data = await response.json();

            if (response.ok) {
                toast.success("POC files updated successfully");
                setPocChanged(false);
                await fetchPoc(id)

            }
            else {
                toast.error(data.message || "Failed to update POC files");
            }

            setPocFiles([]);



        } catch (error) {
            console.error(
                "Update remediation POC error:",
                error
            );
        }
        finally {
            setUpdateLoading(false)
        }
    };


    const normalizedAppType = String(applicationType ?? '')
        .trim()
        .toUpperCase();

    const allowedAppTypes = [
        'WEB',
        'API',
        'ANDROID',
        'ANDROID & IOS',
        'IOS'
    ];


    useEffect(() => {
        if (id) {
            fetchVulnerabilityData(id);
        }
        fetchAllVulnerability()
        fetchPOCImages()
        if (emailVer.endsWith("@isecurion.com")) {
            logout();
            return;
        }
    }, [])

    useEffect(() => {
        if (!id) return;
        setremidiationPoc([]);
        fetchPoc(id);
    }, [id]);

    return (
        <div className="wrap_developer_page">
            <div>
                <div className='client_navabr1'>
                    <ClientNavbar1 />
                </div>
                <div className='navbar_second'><ClientNavbar2 /></div>
            </div>
            <div className="wrap_dev_content">
                <div className={isSidebarCollapsed ? 'clientdash-navbar' : 'clientdash_close_navbar'}>
                    <ClientNavbar />
                </div>

                <div className='view_vulnerabilities_container'>
                    <div className='view_vulnerabilities_main_content'>
                        <div className='view_vulnerabilities_sidebar'>
                            {Array.isArray(allVulnerabilityData) &&
                                [...allVulnerabilityData]
                                    .sort((a, b) => {
                                        const order = ["critical", "high", "medium", "low", "info"];
                                        return (
                                            order.indexOf(a.severity.toLowerCase()) -
                                            order.indexOf(b.severity.toLowerCase())
                                        );
                                    })
                                    .map((vul, index) => (
                                        <div
                                            className={`view_vulnerabilities_sidebar_list ${selectedVulId === vul._id ? "selected" : ""
                                                }`}
                                            key={index}
                                            onClick={() => {
                                                setSelectedVulId(vul._id);
                                                handleVulClick(vul._id);
                                            }}
                                        >
                                            <p>{vul.vulnerabilityName}</p>
                                        </div>
                                    ))}

                        </div>

                        <div className='view_vulnerabilities_main_content_2'>

                            <div className='view_vulnerabilities_main_content_2_name'>
                                <div className='view_vulnerabilities_name'>
                                    <p>{vulnerabilityData?.vulnerabilityName}</p>
                                </div>
                                <div className='view_vulnerabilities_status'>
                                    <p>Status</p>
                                    <div className='view_vulnerabilities_status_value'>

                                        {userPermission === 'level 4' && vulnerabilityData?.bugStatus === 'Open' ? (
                                            <div className='view_vul_accept'>
                                                <button onClick={() => handleAcceptVulnerability(vulnerabilityData?._id)}>Accept</button>
                                            </div>
                                        ) : (
                                            !openAssignDropdown ? (
                                                <>
                                                    <p className={getStatus(vulnerabilityData?.bugStatus)} style={{ fontWeight: 500 }}>{vulnerabilityData?.bugStatus}</p>
                                                    <div className='edit_icon' onClick={(e) => {
                                                        setOpenAssignDropdown(true)
                                                    }}>
                                                        <Icon icon="flowbite:edit-outline" width="20" height="20" />
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="custom-select-wrapper">
                                                    <Dropdown
                                                        options={options}
                                                        setOpenAssignDropdown={setOpenAssignDropdown}
                                                        id={id}
                                                        fetchVulnerabilityData={fetchVulnerabilityData}
                                                    />
                                                </div>
                                            )
                                        )}

                                    </div>
                                </div>
                            </div>
                            <div className='view_vulnerabilities_main_content_2_description'>
                                <h2>Description</h2>
                                <p>{vulnerabilityData?.description}</p>
                            </div>

                            <div className="view_vulnerabilities_main_content_2_information">
                                <h2 className="vuln-info-title">Vulnerability Information</h2>
                                <div className="vuln-info-table">
                                    <div className="vuln-info-row">
                                        <div className="vuln-info-label">Vulnerability Severity</div>
                                        <div className={`vuln-info-value vul-status-${vulnerabilityData?.severity?.toLowerCase().replace(/\s/g, '')}`}>{vulnerabilityData?.severity}</div>
                                    </div>
                                    <div className="vuln-info-row">
                                        <div className="vuln-info-label">CVE ID</div>
                                        <div className="vuln-info-value">{vulnerabilityData?.cveId}</div>
                                    </div>
                                    {console.log('Application Type:', applicationType)}
                                    {allowedAppTypes.includes(normalizedAppType) && (
                                        <div className="vuln-info-row">
                                            <div className="vuln-info-label">OWASP Category</div>
                                            <div className="vuln-info-value">
                                                {vulnerabilityData?.OWASP || 'Not Applicable'}
                                            </div>
                                        </div>
                                    )}

                                    <div className="vuln-info-row">
                                        <div className="vuln-info-label">Assigned To</div>
                                        <div className="vuln-info-value">
                                            <span className="vuln-info-avatar">{vulnerabilityData?.developerName ? vulnerabilityData?.developerName.charAt(0).toUpperCase() : 'U'}</span>  {!vulnerabilityData?.developerName ? 'Unassigned' : vulnerabilityData?.developerName}
                                        </div>
                                    </div>
                                    {applicationType !== 'WEB' && applicationType !== 'API' && applicationType !== 'ANDROID' && applicationType !== 'ANDROID & IOS' && applicationType !== 'IOS' && applicationType !== 'Source Code Review' ? '' : (
                                        <div className="vuln-info-row">
                                            <div className="vuln-info-label">CVSS String</div>
                                            <div className="vuln-info-value">{vulnerabilityData?.cvssString === '' ? 'NA' : vulnerabilityData?.cvssString}</div>
                                        </div>
                                    )}

                                    {applicationType !== 'WEB' && applicationType !== 'API' && applicationType !== 'ANDROID' && applicationType !== 'ANDROID & IOS' && applicationType !== 'IOS' && applicationType !== 'Source Code Review' ? '' : (
                                        <div className="vuln-info-row">
                                            <div className="vuln-info-label">CVSS Score</div>
                                            <div className="vuln-info-value">{vulnerabilityData?.cvssScore === '' ? 'NA' : vulnerabilityData?.cvssScore}</div>
                                        </div>
                                    )}

                                    {applicationType !== 'WEB' && applicationType !== 'API' && applicationType !== 'ANDROID' && applicationType !== 'ANDROID & IOS' && applicationType !== 'IOS' && applicationType !== 'Source Code Review' ? '' : (
                                        <div className="vuln-info-row">
                                            <div className="vuln-info-label">Ease of Exploitation</div>
                                            <div className="vuln-info-value">{vulnerabilityData?.exploitation === '' ? 'NA' : vulnerabilityData?.cvssScore}</div>
                                        </div>
                                    )}

                                    <div className="vuln-info-row">
                                        <div className="vuln-info-label">Upload Date</div>
                                        <div className="vuln-info-value">{formatDate(vulnerabilityData?.discovered)}</div>
                                    </div>
                                    <div className="vuln-info-row">
                                        <div className="vuln-info-label comments">Comments</div>
                                        <div className="vuln-info-value">
                                            {vulnerabilityData?.comments ? vulnerabilityData?.comments : (
                                                <>
                                                    <textarea
                                                        className="vuln-info-comments-textarea"
                                                        placeholder="Add your comments..."
                                                        rows={2}
                                                        value={comments}
                                                        type='text'
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setComments(value)
                                                            setSaveVisible(value.trim() !== '');
                                                        }}
                                                    />
                                                    {saveVisible ? (<span><button onClick={() => handleSaveComment(vulnerabilityData._id)} className='save_comments_button'>Save</button></span>) : ""}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="vuln-info-row" >

                                        <div className="vuln-info-label comments">
                                            POC (Optional)
                                        </div>

                                        <div
                                            className="vuln-info-value"
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                width: '100%'
                                            }}
                                        >

                                            <input
                                                type="file"
                                                id="pocFiles"
                                                accept="image/*"
                                                multiple
                                                onChange={(e) => {
                                                    const files = Array.from(e.target.files || []);

                                                    if (!files.length) return;


                                                    setPocFiles((prev) => [
                                                        ...prev,
                                                        ...files
                                                    ]);


                                                    e.target.value = "";
                                                }}
                                            />

                                            {pocFiles.length > 0 && (
                                                <div style={{ marginTop: '10px', width: '100%' }}>
                                                    {pocFiles.map((file, index) => (
                                                        <div
                                                            key={`${file.name}-${file.size}-${index}`}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between',
                                                                padding: '8px 10px',
                                                                marginBottom: '6px',
                                                                border: '1px solid #ddd',
                                                                borderRadius: '4px'
                                                            }}
                                                        >
                                                            <div>
                                                                <span>
                                                                    POC {index + 1}: {file.name}
                                                                </span>


                                                                <div style={{ marginTop: '8px' }}>
                                                                    <img
                                                                        src={URL.createObjectURL(file)}
                                                                        alt={`POC ${index + 1}`}
                                                                        style={{
                                                                            width: '150px',
                                                                            height: '80px',
                                                                            objectFit: 'cover',
                                                                            borderRadius: '4px'
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setPocFiles((prev) =>
                                                                        prev.filter((_, i) => i !== index)
                                                                    );
                                                                }}
                                                                style={{
                                                                    background: '#e74c3c',
                                                                    border: 'none',
                                                                    color: '#fff',
                                                                    padding: '5px 10px',
                                                                    borderRadius: '4px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '12px'
                                                                }}
                                                            >
                                                                Remove
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}


                                            <div style={{ display: 'flex', gap: "10px", alignItems: "center" }}>
                                                {pocFiles.length > 0 && (
                                                    <label
                                                        htmlFor="pocFiles"
                                                        style={{
                                                            marginTop: '10px',
                                                            width: '120px',

                                                            backgroundColor: '#555',
                                                            color: '#fff',
                                                            padding: '7px 12px',
                                                            borderRadius: '4px',
                                                            fontSize: '13px',
                                                            cursor: 'pointer',
                                                            textAlign: 'center',
                                                            height: "35px",
                                                            display: "flex",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        Add More POC
                                                    </label>
                                                )}

                                                {pocFiles.length > 0 && (
                                                    <button
                                                        type="button"
                                                        disabled={loading}
                                                        onClick={handleSubmitPoc}
                                                        style={{
                                                            marginTop: '12px',
                                                            width: '100px',
                                                            backgroundColor: '#3b5fe5',
                                                            color: '#fff',
                                                            border: 'none',
                                                            padding: '7px 12px',
                                                            borderRadius: '4px',
                                                            fontSize: '14px',
                                                            height: "35px",
                                                            cursor: loading ? "not-allowed" : "pointer"
                                                        }}
                                                    >
                                                        {loading ? "Submitting" : "Submit"}
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                    </div>

                                    <div className="vuln-info-row" style={{ display: 'flex' }}>
                                        <div className="vuln-info-label comments"></div>
                                        <div className="vuln-info-value"
                                            style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '15px',
                                                alignItems: 'flex-start',
                                                marginTop: '20px',
                                                width: '100%'
                                            }}
                                        >
                                            {remidiationPoc.map((poc, index) => (
                                                <div
                                                    key={index} style={{ position: 'relative', width: '200px', height: '120px' }}
                                                >
                                                    <img onClick={() => setViewPocIndex(index)}
                                                        src={poc.objectUrl}
                                                        alt={`Remediation POC ${index + 1}`}
                                                        style={{ width: '200px', height: '120px', objectFit: 'cover', borderRadius: '4px', display: 'block' }}
                                                    />

                                                    <button type="button"
                                                        onClick={() => {
                                                            setremidiationPoc((prev) =>
                                                                prev.filter((_, i) => i !== index)
                                                            );
                                                            setPocChanged(true);
                                                        }}
                                                        style={{ position: 'absolute', top: '5px', right: '5px', width: '24px', height: '24px', borderRadius: '50%', border: 'none', background: '#e74c3c', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold', padding: 0, lineHeight: 1 }} >
                                                        ×
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    {viewPocIndex !== null && (
                                        <div
                                            onClick={() => setViewPocIndex(null)}
                                            style={{
                                                position: 'fixed',
                                                inset: 0,
                                                background: 'rgba(0, 0, 0, 0.85)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                zIndex: 9999
                                            }}
                                        >
                                            <img
                                                src={remidiationPoc[viewPocIndex].objectUrl}
                                                alt="POC Preview"
                                                onClick={(e) => e.stopPropagation()}
                                                style={{
                                                    width: '50%',
                                                    height: '50%',
                                                    objectFit: 'contain',
                                                    borderRadius: '6px'
                                                }}
                                            />

                                            {/* Close */}
                                            <button
                                                type="button"
                                                onClick={() => setViewPocIndex(null)}
                                                style={{
                                                    position: 'absolute',
                                                    top: '20px',
                                                    right: '25px',
                                                    fontSize: '30px',
                                                    color: '#fff',
                                                    background: 'transparent',
                                                    border: 'none',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                ×
                                            </button>

                                            {/* Previous */}
                                            {remidiationPoc.length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.stopPropagation();

                                                        setViewPocIndex((prev) =>
                                                            prev === 0
                                                                ? remidiationPoc.length - 1
                                                                : prev - 1
                                                        );
                                                    }}
                                                    style={{
                                                        position: 'absolute',
                                                        left: '30px',
                                                        top: '50%',
                                                        fontSize: '50px',
                                                        color: '#fff',
                                                        background: 'transparent',
                                                        border: 'none',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    ‹
                                                </button>
                                            )}

                                            {/* Next */}
                                            {remidiationPoc.length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.stopPropagation();

                                                        setViewPocIndex((prev) =>
                                                            prev === remidiationPoc.length - 1
                                                                ? 0
                                                                : prev + 1
                                                        );
                                                    }}
                                                    style={{
                                                        position: 'absolute',
                                                        right: '30px',
                                                        top: '50%',
                                                        fontSize: '50px',
                                                        color: '#fff',
                                                        background: 'transparent',
                                                        border: 'none',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    ›
                                                </button>
                                            )}

                                            {/* Counter */}
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '25px',
                                                    color: '#fff',
                                                    fontSize: '14px'
                                                }}
                                            >
                                                {viewPocIndex + 1} / {remidiationPoc.length}
                                            </div>
                                        </div>
                                    )}
                                    <div >
                                        {pocChanged && (
                                            <button
                                                type="button"
                                                disabled={updateLoading}
                                                onClick={handleUpdatePoc}
                                                style={{
                                                    marginTop: '12px',
                                                    backgroundColor: '#3b5fe5',
                                                    color: '#fff',
                                                    border: 'none',
                                                    padding: '7px 15px',
                                                    borderRadius: '4px',
                                                    fontSize: '14px',
                                                    width: "100px",
                                                    cursor: updateLoading ? 'not-allowed' : 'pointer'
                                                }}
                                            >
                                                {updateLoading ? 'Updating...' : 'Update'}
                                            </button>
                                        )}
                                    </div>

                                    {vulnerabilityData?.retestStatus ? (
                                        <div className="vuln-info-row">
                                            <div className="vuln-info-label">Retest Status</div>
                                            <div className="vuln-info-value">{vulnerabilityData?.retestStatus}</div>
                                        </div>
                                    ) : ''}

                                </div>
                            </div>

                            <div className='view_vulnerabilities_main_content_2_attachemnts'>
                                <ViewVulnerabilitiesAttachment
                                    vulnerabilityData={vulnerabilityData}
                                    setVulnerabilityData={setVulnerabilityData}
                                    setPocImages={setPocImages}
                                    pocImages={pocImages}
                                    applicationType={applicationType}

                                />
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div >
    )
}

export default ViewVulnerabilities